//GeneratorFlag:[NoChange]
<template>
	<div>kaveh.app.toolbar.hub.notification</div>
</template>